<template>
  <header class="header" :class="{'is-menu-fadein': this.fadein }">
    <div class="header__logo">
      <h1>
        <router-link to="/">
          <svg viewBox="0 0 539.13 145.071">
            <g class="nk">
              <path
                d="M185.997,0.096h-3.509c-9.651,0-17.547,7.896-17.547,17.547v108.962c0,9.65,7.896,17.547,17.547,17.547
                    h3.509c9.651,0,17.547-7.896,17.547-17.547V17.643C203.544,7.991,195.648,0.096,185.997,0.096z"
              />
              <path
                d="M296.104,55.073h-0.146h-3.363h-11.402l25.912-21.271c7.459-6.123,8.553-17.236,2.429-24.695l-2.227-2.713
                    c-6.123-7.459-17.237-8.553-24.696-2.429l-64.529,52.973c-0.256,0.21-0.504,0.428-0.745,0.649
                    c-5.099,3.079-8.527,8.675-8.527,15.033v1.258c0,9.65,7.896,17.547,17.547,17.547h48.692v35.18c0,9.65,7.896,17.547,17.547,17.547
                    h3.51c9.65,0,17.547-7.896,17.547-17.547V72.62C313.651,62.97,305.755,55.073,296.104,55.073z"
              />
              <path
                d="M128.97,0.096h-3.51H21.056h-3.509C7.896,0.096,0,7.991,0,17.643v3.509v105.453
                    c0,9.65,7.896,17.547,17.547,17.547h3.509c9.651,0,17.547-7.896,17.547-17.547V38.698h69.311v87.906
                    c0,9.65,7.896,17.547,17.547,17.547h3.51c9.651,0,17.547-7.896,17.547-17.547V21.151v-3.509
                    C146.517,7.991,138.621,0.096,128.97,0.096z"
              />
            </g>
            <g class="tech">
              <path
                d="M367.746,144.271h-15.829V98.624h-14.308V85.68h44.404v12.944h-14.268V144.271z"
              />
              <path
                d="M425.128,144.271h-34.785V85.68h34.785v12.704h-18.955v9.217h17.553v12.705h-17.553v11.061h18.955V144.271z"
              />
              <path
                d="M461.797,97.822c-3.767,0-6.706,1.543-8.816,4.629s-3.166,7.341-3.166,12.764c0,11.274,4.288,16.912,12.864,16.912
                    c2.592,0,5.103-0.36,7.535-1.082c2.431-0.722,4.875-1.589,7.333-2.604v13.385c-4.889,2.164-10.42,3.246-16.591,3.246
                    c-8.844,0-15.623-2.564-20.339-7.694s-7.073-12.544-7.073-22.241c0-6.065,1.143-11.396,3.427-15.991
                    c2.284-4.595,5.57-8.128,9.858-10.6c4.287-2.472,9.331-3.707,15.129-3.707c6.331,0,12.383,1.376,18.153,4.128l-4.849,12.463
                    c-2.164-1.015-4.328-1.869-6.492-2.564C466.606,98.17,464.282,97.822,461.797,97.822z"
              />
              <path
                d="M539.13,144.271h-15.91v-23.886h-18.395v23.886h-15.91V85.68h15.91V107.4h18.395V85.68h15.91V144.271z"
              />
            </g>
          </svg>
        </router-link>
      </h1>
    </div>
    <button class="menu-btn" @click="menuOpen">
      <span class="menu-btn__txt">
        <span>M</span>
        <span>E</span>
        <br />
        <span>N</span>
        <span>U</span>
      </span>
      <svg viewBox="0 0 26.9 26.2" class="menu-btn__close">
        <polygon
          points="24,0 13.4,10.6 2.8,0 0.7,2.1 11.3,12.7 0,24 2.1,26.2 13.4,14.8 24.7,26.2 26.9,24 15.6,12.7
                26.2,2.1 	"
        />
      </svg>
    </button>
    <div class="menu-wrap" v-show="menu">
      <nav class="menu">
        <ul class="menu__wrap">
          <li class="menu__item">
            <span @click="menuClick">
              <router-link to="/">HOME</router-link>
            </span>
          </li>
          <li class="menu__item">
            <span @click="menuClick">
              <router-link to="/works">WORKS</router-link>
            </span>
          </li>
          <li class="menu__item">
            <span @click="menuClick">
              <a href="https://secure.multi.ne.jp/nk/nk-tech/contact/">CONTACT</a>
            </span>
          </li>
        </ul>
        <ul class="menu__site">
          <li class="menu__site-item">
            <a href="https://www.multi.ne.jp/" target="_blank">
              <span class="menu__site-en">CORPORATE</span>
            </a>
          </li>
          <li class="menu__site-item">
            <a href="http://www.system-shop.jp/" target="_blank">
              <span class="menu__site-en">SYSTEM</span>
            </a>
          </li>
          <li class="menu__site-item">
            <a href="http://www.nk-school.com/" target="_blank">
              <span class="menu__site-en">SCHOOL</span>
            </a>
          </li>
        </ul>
      </nav>
      <div class="menu__address">
        <div class="menu__map">
          <GmapMap
            :center="center"
            :zoom="15"
            :options="mapStyle"
            style="width: 100%; height: 100%;"
          >
            <GmapMarker
              :position="{ lat: 37.395945, lng: 140.362401 }"
              :clickable="true"
              :draggable="false"
              @click="center=m.position"
            />
          </GmapMap>
        </div>
        <p class="menu__txt">
          〒963-8861
          <br />福島県郡山市鶴見坦1-14-5
        </p>
        <p class="menu__txt">TEL.024-923-1913／FAX.024-938-2328</p>
      </div>
    </div>
  </header>
</template>


<script>
export default {
  name: "Header",
  data() {
    return {
      menu: false,
      fadein: false,
      center: { lat: 37.395945, lng: 140.362401 },
      mapStyle: {
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#212121"
              }
            ]
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                color: "#212121"
              }
            ]
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#212121"
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd"
              }
            ]
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#181818"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1b1b1b"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c2c2c"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8a8a8a"
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#373737"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#3c3c3c"
              }
            ]
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#4e4e4e"
              }
            ]
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161"
              }
            ]
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#000000"
              }
            ]
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3d3d3d"
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    menuOpen: function() {
      if (!this.menu) {
        this.menu = true;
      } else {
        setTimeout(() => {
          this.menu = false;
        }, 500);
      }

      setTimeout(() => {
        this.fadein = !this.fadein;
      }, 100);
    },
    menuClose: function() {
      this.fadein = false;
      this.menu = false;
    },
    menuClick: function() {
      setTimeout(() => {
        this.menu = false;
        this.fadein = false;
      }, 1000);
    }
  }
};
</script>


<style lang="scss">
</style>
